// Vendor
import * as React from 'react';

// Internal
import { ChartResaleAccelerate } from '@src/charts/ChartResaleAccelerate';
import { Image } from '@src/components/Image';
import { SlideReveal } from '@src/components/SlideReveal';
import { DEFAULT_SAL_PROPS, SAL_DELAY } from '@src/config/sal';

const PoisedToAccelerate: React.FC = () => {
  return (
    <div className="tup-slide">
      <h1 {...DEFAULT_SAL_PROPS} className="max-w-2xl">
        Resale is Poised to Accelerate
      </h1>

      <h2
        {...DEFAULT_SAL_PROPS}
        data-sal-delay={SAL_DELAY * 1}
        className="max-w-xl"
      >
        Resale is expected to grow 5X over the next 5 years, while retail is
        projected to shrink.
      </h2>

      <div className="relative hidden md:block" style={{ height: 480 }}>
        <ChartResaleAccelerate />
        <p
          {...DEFAULT_SAL_PROPS}
          data-sal-delay={SAL_DELAY * 2}
          className="absolute text-center top-0 left-0 ml-16 mt-24"
          style={{ maxWidth: 220 }}
        >
          In 2019, resale grew <b>25X</b> faster than the broader retail sector.
          Resale: <b>49%</b>, Retail: <b>2%</b>
        </p>
      </div>
      <SlideReveal>
        <Image
          alt="Resale Growth Chart"
          addLink={true}
          className="block md:hidden"
          fileName="1e-chart-mobile.png"
        />
      </SlideReveal>
      <p data-sal-delay={SAL_DELAY * 2} className="tup-description">
        2019-2024 projected market growth<sup>1</sup>
      </p>
      <p data-sal-delay={SAL_DELAY * 2} className="tup-source">
        GlobalData Market Sizing and Growth Estimates
      </p>
    </div>
  );
};

export { PoisedToAccelerate };
